export const RESOURCE_ALLOCATION_PERMISSION = {
  VIEW_RESOURCE_ALLOCATION:
    'urn:replicon:resource-allocation-action:view-resource-allocation',
  EDIT_RESOURCE_ALLOCATION:
    'urn:replicon:resource-allocation-action:edit-resource-allocation',
  WEBUI_EDIT_COMPLETE_RESOURCE_ALLOCATION:
    'urn:replicon-webui:completed-resource-allocation:edit'
};

export const RESOURCE_REQUEST_PERMISSION = {
  VIEW_RESOURCE_ASSIGNMNET:
    'urn:replicon:resource-assignment-action:view-resource-assignments'
};
